/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import { put, takeEvery } from 'redux-saga/effects';

import { API_HOSTNAME, CAPTCHA } from '../app/Api';
import {
    requestCaptchaFailed,
    setImageCaptcha,
} from './captchaActions';
import { REQUEST_CAPTCHA } from './captchaConstants';

export function* requestCaptchaSaga() {
    try {
        yield put(setImageCaptcha({ captchaImage: `${API_HOSTNAME}${CAPTCHA}` }));
    } catch (error) {
        yield put(requestCaptchaFailed());
    }
}

export function* captchaSagas() {
    yield takeEvery(REQUEST_CAPTCHA, requestCaptchaSaga);
}
